function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M15,5 C9.4771525,5 5,9.4771525 5,15 C5,20.5228475 9.4771525,25 15,25 C20.5228475,25 25,20.5228475 25,15 C25,9.4771525 20.5228475,5 15,5 Z M19.6496852,17.9583417 C19.9518136,18.2604709 20.0698082,18.7008339 19.9592215,19.1135501 C19.8486349,19.5262664 19.5262677,19.8486344 19.1135526,19.9592214 C18.7008375,20.0698084 18.2604757,19.9518135 17.9583473,19.6496842 L15,16.6913289 L12.0416528,19.6496842 C11.7395243,19.9518135 11.2991626,20.0698084 10.8864474,19.9592214 C10.4737323,19.8486344 10.1513651,19.5262664 10.0407785,19.1135501 C9.93019179,18.7008339 10.0481864,18.2604709 10.3503148,17.9583417 L13.3086621,14.9999864 L10.3503148,12.041631 C9.88326478,11.5745797 9.88326479,10.8173399 10.3503149,10.3502885 C10.8173649,9.8832372 11.5746027,9.88323719 12.0416528,10.3502885 L15,13.3086438 L17.9583473,10.3502885 C18.4253973,9.88323716 19.1826351,9.88323716 19.6496852,10.3502885 C20.1167353,10.8173399 20.1167353,11.5745797 19.6496852,12.041631 L16.6913379,14.9999864 L19.6496852,17.9583417 Z",
  id: "path-1"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "acompanhamento-mobile-BETA-REAL",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "beta-busca-7",
  transform: "translate(-107.000000, -402.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-3",
  transform: "translate(107.000000, 402.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "illustra"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-5",
  transform: "translate(74.914286, 25.855706)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#D8DDEB",
  x: 0,
  y: 0,
  width: 56.5142857,
  height: 23.6552203,
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "M40.7428571,0 L50.1138783,0 L50.1138783,8.08625946 C50.1138783,9.19082896 49.2184478,10.0862595 48.1138783,10.0862595 L42.7428571,10.0862595 C41.6382876,10.0862595 40.7428571,9.19082896 40.7428571,8.08625946 L40.7428571,0 L40.7428571,0 Z",
  id: "Rectangle",
  fill: "#B3BECD"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-2",
  fill: "#B3BECD",
  x: 0,
  y: 0,
  width: 34.8285714,
  height: 23.6552203,
  rx: 2
})), /*#__PURE__*/React.createElement("g", {
  id: "Group-5",
  transform: "translate(6.571429, 0.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#D8DDEB",
  x: 0,
  y: 0,
  width: 63.7428571,
  height: 49.5109261,
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.8285714,0 L48.6285714,0 L48.6285714,8.08625946 C48.6285714,9.19082896 47.7331409,10.0862595 46.6285714,10.0862595 L36.8285714,10.0862595 C35.7240019,10.0862595 34.8285714,9.19082896 34.8285714,8.08625946 L34.8285714,0 L34.8285714,0 Z",
  id: "Rectangle",
  fill: "#B3BECD"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-2",
  fill: "#B3BECD",
  x: 2.33464042e-15,
  y: 0,
  width: 23.6571429,
  height: 49.5109261,
  rx: 2
})), /*#__PURE__*/React.createElement("g", {
  id: "illustration-copy-2",
  transform: "translate(39.979724, 20.354492)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-5",
  transform: "translate(0.105991, 0.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#D8DDEB",
  x: 0.0414165666,
  y: 0,
  width: 58.7362218,
  height: 30.3672328,
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "M44.6207028,0 L53.0546218,0 L53.0546218,7.11016983 C53.0546218,8.21473933 52.1591913,9.11016983 51.0546218,9.11016983 L46.6207028,9.11016983 C45.5161333,9.11016983 44.6207028,8.21473933 44.6207028,7.11016983 L44.6207028,0 L44.6207028,0 Z",
  id: "Rectangle",
  fill: "#B3BECD"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-2",
  fill: "#F5F8FA",
  x: 0.0414165666,
  y: 0,
  width: 39.1574812,
  height: 30.3672328,
  rx: 2
}), /*#__PURE__*/React.createElement("g", {
  id: "Group-6",
  transform: "translate(10.885027, 8.097929)",
  fill: "#D8DDEB",
  opacity: 0.3
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 0,
  y: 0,
  width: 18.0726836,
  height: 9.11016983,
  rx: 2
})), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy-5",
  fill: "#D8DDEB",
  x: 13.2947179,
  y: 23.6556631,
  width: 13.2533013,
  height: 1.6503642,
  rx: 0.825182102
}))), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#B3BECD",
  x: 0,
  y: 49.5109261,
  width: 138,
  height: 1.1002428,
  rx: 0.550121401
})), /*#__PURE__*/React.createElement("g", {
  id: "Group-2",
  transform: "translate(116.000000, 10.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#FFFFFF",
  cx: 15,
  cy: 15,
  r: 8
}), /*#__PURE__*/React.createElement("g", {
  id: "icons-/-circle-/-delete"
}, /*#__PURE__*/React.createElement("rect", {
  id: "bound",
  x: 0,
  y: 0,
  width: 30,
  height: 30
}), /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("use", {
  id: "ico-circle-delete",
  fill: "#FF6562",
  xlinkHref: "#path-1"
}))))));

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "146px",
    height: "53px",
    viewBox: "0 0 146 53",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.265d5ccf.svg";
export { ForwardRef as ReactComponent };